export { PhotoPicker } from './components/molecules/PhotoPicker/PhotoPicker';
export { defaultUploadFiles } from './components/molecules/PhotoPicker/defaultUploadFiles';
export type {
  PhotoPickerProps,
  PhotoPickerCopy,
  ImageUploadSlot,
  RequestUploadSlots,
  UploadFiles,
} from './components/molecules/PhotoPicker/types';
